module.exports = __webpack_public_path__ + "img/settingicon.6ea4983c.svg";